import axios from "axios";
import { API_GATEWAY, PR_DEP } from "../../config/globalVariables";

class EtkinlikMailService {
  getLatestMailBody(etkinlikTanimId, tip) {
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/etkinlikmail/get-latest-mail-body/${etkinlikTanimId}/${tip}`
      )
      .then((response) => {
        return response.data;
      });
  }
}

export default new EtkinlikMailService();
